//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import Header from "@/components/Header.vue";
import Footer from "@/components/Footer.vue";
import LoadContainer from "@/components/LoadContainer.vue";
import MemberMenuCount from "./components/MemberMenuCount.vue";
export default {
  name: "Member",
  components: {
    Header: Header,
    Footer: Footer,
    LoadContainer: LoadContainer,
    MemberMenuCount: MemberMenuCount
  },
  data: function data() {
    return {
      fixedFooter: false,
      isLoaded: false,
      activeMenuRoute: this.$route.name
    };
  },
  created: function created() {
    this.$store.commit("setBreads", this.$route);
    this.$store.dispatch("refreshMessageState");
    this.$store.dispatch("refreshHomeworkState");
    this.$store.dispatch("get_user_info");
    this.initFooter();

    if (this.$route.name == "MemberMyConsultation") {
      this.isLoaded = true;
    }
  },
  computed: {
    iconUrl: function iconUrl() {
      return this.$store.state.commonSetting.not_vip_icon;
    },
    user: function user() {
      return this.$store.state.user_info;
    },
    breads: function breads() {
      var data = this.$store.state.breads || [];

      if (data.length > 1) {
        data.forEach(function (item) {
          if (item.name == "MemberPeriods" && item.query && item.query.tab == "periods") {
            item.title = "我的约排课";
            item.query.tab = "otn";
          }
        });
      }

      return data;
    },
    commonSetting: function commonSetting() {
      return this.$store.state.commonSetting;
    },
    menus: function menus() {
      var result = [{
        route: "MemberCalendar",
        icon: require("@/assets/images/member/icon-calendar.png"),
        iconActive: require("@/assets/images/member/icon-calendar-active.png"),
        title: "学习日历"
      }, {
        route: "MemberStudy",
        icon: require("@/assets/images/member/icon-course.png"),
        iconActive: require("@/assets/images/member/icon-course-active.png"),
        title: "我的课程"
      }, // {
      //   route: "SubmenuCourse",
      //   icon: require("@/assets/images/member/icon-course.png"),
      //   iconActive: require("@/assets/images/member/icon-course-active.png"),
      //   title: "学习中心",
      //   children: [
      //     {
      //       route: "MemberStudy",
      //       title: "我的课程",
      //     },
      //     {
      //       route: "MemberClasses",
      //       title: "我的班级",
      //       hide: this.commonSetting.switch_class_module != 1,
      //     },
      //     {
      //       route: "MemberOto",
      //       title: "我的约课",
      //       hide: this.commonSetting.switch_oto_module != 1,
      //     },
      //     {
      //       route: "MemberPeriods",
      //       query: { tab: "otn" },
      //       title: "我的约排课",
      //       hide: this.commonSetting.switch_contract_schedule != 1,
      //     },
      //   ],
      // },
      {
        route: "SubmenuPractise",
        icon: require("@/assets/images/member/icon-practise.png"),
        iconActive: require("@/assets/images/member/icon-practise-active.png"),
        title: "练习中心",
        children: [{
          route: "MemberEvaluation",
          title: "我的测评",
          hide: this.commonSetting.switch_question_module != 1
        }, {
          route: "MemberHomeworkIndex",
          title: "我的作业",
          countType: "homework",
          hide: this.commonSetting.class_homework_module != 1
        }, {
          route: "MemberTest",
          title: "考试中心",
          countType: "test",
          hide: this.commonSetting.switch_question_module != 1
        }]
      }, {
        route: "MemberEbooks",
        icon: require("@/assets/images/member/icon-ebook.png"),
        iconActive: require("@/assets/images/member/icon-ebook-active.png"),
        title: "我的电子书",
        hide: this.commonSetting.switch_ebook_module != 1
      }, // {
      //   route: "MemberCert",
      //   icon: require("@/assets/images/member/icon-cert.png"),
      //   iconActive: require("@/assets/images/member/icon-cert-active.png"),
      //   title: "我的证书",
      //   hide: this.commonSetting.switch_cert_module != 1,
      // },
      // {
      //   route: "SubmenuWealth",
      //   icon: require("@/assets/images/member/icon-wealth.png"),
      //   iconActive: require("@/assets/images/member/icon-wealth-active.png"),
      //   title: "资产中心",
      //   children: [
      //     {
      //       route: "MemberWealth",
      //       title: "我的财富",
      //       hide:
      //         this.commonSetting.switch_coupon_module != 1 &&
      //         this.commonSetting.switch_study_module != 1,
      //     },
      //     {
      //       route: "MemberIntegral",
      //       title: "我的" + this.commonSetting.point_info.point_name,
      //       hide: this.commonSetting.switch_integral_module != 1,
      //     },
      //     {
      //       route: "MemberClockin",
      //       title: "我的打卡",
      //       hide: this.commonSetting.switch_take_module != 1,
      //     },
      //   ],
      // },
      {
        route: "SubmenuOrder",
        icon: require("@/assets/images/member/icon-order.png"),
        iconActive: require("@/assets/images/member/icon-order-active.png"),
        title: "订单中心",
        children: [{
          route: "MemberOrder",
          title: "我的订单"
        }, {
          route: "MemberAddress",
          title: "收货地址"
        }]
      }, {
        route: "MemberCommunity",
        icon: require("@/assets/images/member/icon-community.png"),
        iconActive: require("@/assets/images/member/icon-community-active.png"),
        title: "我的圈子",
        hide: this.commonSetting.switch_community_module != 1
      }, // {
      //   route: "MemberMyConsultation",
      //   icon: require("@/assets/images/member/icon-consultation.png"),
      //   iconActive: require("@/assets/images/member/icon-consultation-active.png"),
      //   title: "我的咨询",
      //   countType: "0",
      //   hide: this.commonSetting.switch_consult_module != 1,
      // },
      {
        route: "MemberMessage",
        icon: require("@/assets/images/member/icon-message.png"),
        iconActive: require("@/assets/images/member/icon-message-active.png"),
        title: "消息中心",
        countType: "message"
      }, {
        route: "MemberProfile",
        icon: require("@/assets/images/member/icon-person.png"),
        iconActive: require("@/assets/images/member/icon-person-active.png"),
        title: "个人设置"
      }];
      return result;
    }
  },
  watch: {
    $route: function $route() {
      this.$store.commit("setBreads", this.$route);
      this.activeMenuRoute = this.$route.name;

      if (this.$route.name == "MemberMyConsultation") {
        this.isLoaded = true;
      }
    },
    commonSetting: function commonSetting() {
      this.initFooter();
    }
  },
  methods: {
    onClickMenuItem: function onClickMenuItem(menu) {
      this.$router.push({
        name: menu.route,
        query: menu.query
      });
    },
    onMenuClick: function onMenuClick() {
      this.isLoaded = false;
    },
    getBreads: function getBreads(data) {
      var breads = data.split("/");
      return breads;
    },
    //判断会员是否过期
    getIsExpire: function getIsExpire(time) {
      if (time) {
        var now = this.$actionTool.getCurTimestamp(); //当前时间的时间戳

        if (now > time) {
          //如果当前时间大于会员到期时间，说明已过期
          return true;
        }
      }

      return false;
    },
    initFooter: function initFooter() {
      var _this = this;

      this.$nextTick(function () {
        if (document.body.clientHeight < document.documentElement.clientHeight - 178) {
          _this.fixedFooter = true;
        } else {
          _this.fixedFooter = false;
        }

        var height = _this.$refs.left.clientHeight;

        _this.$store.commit("setMemberLeftHeight", height);
      });
    }
  }
};